import { productQuantityBreakPricingStyles } from "@insite/content-library/Components/ProductQuantityBreakPricing";
import { css } from "styled-components";

productQuantityBreakPricingStyles.breakPriceHeader = {
    alignX: "center",
    css: css`
        font-family: "MontserratRegular";
    `,
};
productQuantityBreakPricingStyles.savingsCell = {
    alignX: "center",
    css: css`
        font-family: "MontserratRegular";
    `,
};
productQuantityBreakPricingStyles.viewLink = {
    css: css`
        font-family: "MontserratRegular" !important;
        font-size: 14px;
        font-weight: 100;
    `,
};
productQuantityBreakPricingStyles.breakPriceCell = {
    alignX: "center",
    css: css`
        font-family: "MontserratRegular";
    `,
};
productQuantityBreakPricingStyles.breakQtyHeader = {
    alignX: "center",
    css: css`
        font-family: "MontserratRegular";
    `,
};
productQuantityBreakPricingStyles.savingsHeader = {
    alignX: "center",
    css: css`
        font-family: "MontserratRegular";
    `,
};
productQuantityBreakPricingStyles.modal = {
    cssOverrides: {
        modalContent: css`
            padding: 0;
            font-family: "MontserratRegular";
        `,
        modalTitle: css`
            padding: 10px 10px 10px 20px;
            font-family: "MontserratRegular";
        `,
        headlineTypography: css`
            font-size: 20px;
            margin-bottom: 0;
            font-family: "MontserratRegular";
        `,
    },
};
